export default __webpack_public_path__ + "static/media/fav-16x16.97aa8a79.png";